import { SVGProps } from 'react';

const SvgReplyAll = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M208.5 73.4c9.6-9.1 10-24.3.9-33.9s-24.3-10-33.9-.9L33.8 173.2c-19.9 18.9-19.9 50.7 0 69.6l141.7 134.6c9.6 9.1 24.8 8.7 33.9-.9s8.7-24.8-.9-33.9L66.8 208 208.5 73.4zM352 240h-24c-13.3 0-24 10.7-24 24v52.1L183.9 208 304 99.9V152c0 13.3 10.7 24 24 24h72c70.7 0 128 57.3 128 128 0 15.3-1.9 29.1-5.2 41.5C506 284.7 450.2 240 384 240h-32zm0 96v-48h32c5.4 0 10.8.5 16 1.3 45.4 7.6 80 47.1 80 94.7 0 17.3-4.2 30.5-9.5 40.2-1.6 2.9-3.3 5.5-5 7.9-2.6 3.5-5.3 6.4-7.7 8.6-.5.5-1 .9-1.4 1.4-4.8 4.9-8.3 11.3-8.3 18.1 0 10.9 8.8 19.7 19.7 19.7 2.8 0 5.6-.6 8.1-1.9 2.6-1.4 6.3-3.5 10.8-6.5 2.7-1.8 5.7-3.8 8.9-6.2 3.7-2.7 7.6-5.8 11.7-9.3 30.1-25.8 68.7-74 68.7-152 0-97.2-78.8-176-176-176h-48V64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144c-6.7 6.1-10.6 14.7-10.6 23.8s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2v-16z" />
  </svg>
);
export default SvgReplyAll;
